export default function getResource(label, vars = []) {
    const resources = {
        shadeFinderTitle: 'Find your shade'
    };

    return resources[label];
}
